import { render, staticRenderFns } from "./CampusModal.vue?vue&type=template&id=7b007408&scoped=true&"
import script from "./CampusModal.vue?vue&type=script&lang=ts&"
export * from "./CampusModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampusModal.vue?vue&type=style&index=0&id=7b007408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b007408",
  null
  
)

export default component.exports